import {React} from 'react'
import {CodeDiv} from '../../index'
import '../Blog.css'
export default function CheetSheetTemplate(props) {
    return (
        <>

            <div  className={`flex ${props.divStyle}`}>
                <h4 className={props.headStyle}>{props.heading} </h4>
                <p className={`blogContent ${props.class}`}>{props.des}</p>
                <div className={`imgDiv ${props.imgClass}`}>
                    <img src={props.img} alt='' className={`flex center justifyCenter imgWidth imgStyle ${props.imgCss}`} />
                </div>
            </div>
            <CodeDiv code={props.code} url={props.url} headerStyle={props.headerStyle} />
        </>
    )
}
